import { SkatingPass } from '@types';
import { RequestApi } from '_helpers';

const getSkatingPasses = () => {
  return RequestApi.get<SkatingPass>(`/SkatingPass/active`);
};

const createSkatingPassBooking = async (userData: FormData) => {
  const response = await RequestApi.post(
    '/skatingPass/createSkatingPassBooking',
    userData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response;
};

const skatingPassService = { getSkatingPasses, createSkatingPassBooking };

export default skatingPassService;
